import React from "react";
import { FaFeatherAlt } from "react-icons/fa";

const FloatingComposeButton = () => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-20 right-4 z-40 w-14 h-14 bg-spiders-primary-500 hover:bg-spiders-primary-600 text-white rounded-full shadow-lg shadow-spiders-primary-500/25 flex items-center justify-center transition-all hover:scale-105 lg:hidden"
      aria-label="Compose post"
    >
      <FaFeatherAlt className="w-5 h-5" />
    </button>
  );
};

export default FloatingComposeButton;
